exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._13voJFXIhrBj0j4E93lx-X {\n  /* Spelled out so the horizontal padding cannot push the wrapper past 100%\n     and trigger AppWrapper's scrollbar. */\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  /* No bottom padding (mirroring AppIaRWrapper's pt-only) so the embedded map\n     reaches the bottom edge of the viewport. */\n  padding: 30px 32px 0;\n}\n", ""]);

// Exports
exports.locals = {
	"wrapper": "_13voJFXIhrBj0j4E93lx-X"
};